import {FontVariants} from '@mintdata/mint-kit/api/models/FontItem';
import {AString} from '@mintdata/mint-kit/api/values/AString';

export enum FontVariant
{
    THIN = '100',
    THIN_ITALIC = '100italic',

    EXTRA_LIGHT = '200',
    EXTRA_LIGHT_ITALIC = '200italic',

    LIGHT = '300',
    LIGHT_ITALIC = '300italic',

    REGULAR = 'regular',
    ITALIC = 'italic',

    MEDIUM = '500',
    MEDIUM_ITALIC = '500italic',

    SEMI_BOLD = '600',
    SEMI_BOLD_ITALIC = '600italic',

    BOLD = '700',
    BOLD_ITALIC = '700italic',

    EXTRA_BOLD = '800',
    EXTRA_BOLD_ITALIC = '800italic',

    BLACK = '900',
    BLACK_ITALIC = '900italic',
}

// export enum FontVariantTitle
// {
// 	THIN = 'Thin',
// 	THIN_ITALIC = 'Thin Italic',
//
// 	EXTRA_LIGHT = 'Extra Light',
// 	EXTRA_LIGHT_ITALIC = 'Extra Light Italic',
//
// 	LIGHT = 'Light',
// 	LIGHT_ITALIC = 'Light Italic',
//
// 	REGULAR = 'Regular',
// 	ITALIC = 'Italic',
//
// 	MEDIUM = 'Medium',
// 	MEDIUM_ITALIC = 'Medium Italic',
//
// 	SEMI_BOLD = 'Semi-Bold',
// 	SEMI_BOLD_ITALIC = 'Semi-Bold Italic',
//
// 	BOLD = 'Bold',
// 	BOLD_ITALIC = 'Bold Italic',
//
// 	EXTRA_BOLD = 'Extra Bold',
// 	EXTRA_BOLD_ITALIC = 'Extra Bold Italic',
//
// 	BLACK = 'Black',
// 	BLACK_ITALIC = 'Black Italic',
// }

enum FontStyle
{
    NORMAL = 'normal',
    ITALIC = 'italic',
}

type FontWeightCSSValue = 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900;
type FontStyleCSSValue = FontStyle.NORMAL | FontStyle.ITALIC;

type FontVariantTitle = string;
type GoogleFontVariantParam = string;

type FontVariantItems = {[key:string]:FontVariantItem};

interface FontVariantItem
{
    title:FontVariantTitle;
    fontWeight:FontWeightCSSValue;
    fontStyle:FontStyleCSSValue;
    googleFontVariantParam:GoogleFontVariantParam;
}

const fontVariantItems:FontVariantItems =
    {
        [FontVariant.THIN]: {
            title: 'Thin',
            fontWeight: 100,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '100',
        },
        [FontVariant.THIN_ITALIC]: {
            title: 'Thin Italic',
            fontWeight: 100,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '100i',
        },
        [FontVariant.EXTRA_LIGHT]: {
            title: 'Extra-Light',
            fontWeight: 200,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '200',
        },
        [FontVariant.EXTRA_LIGHT_ITALIC]: {
            title: 'Extra-Light Italic',
            fontWeight: 200,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '200i',
        },
        [FontVariant.LIGHT]: {
            title: 'Light',
            fontWeight: 300,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '300',
        },
        [FontVariant.LIGHT_ITALIC]: {
            title: 'Light Italic',
            fontWeight: 300,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '300i',
        },
        [FontVariant.REGULAR]: {
            title: 'Regular',
            fontWeight: 400,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: 'regular',
        },
        [FontVariant.ITALIC]: {
            title: 'Italic',
            fontWeight: 400,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: 'italic',
        },
        [FontVariant.MEDIUM]: {
            title: 'Medium',
            fontWeight: 500,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '500',
        },
        [FontVariant.MEDIUM_ITALIC]: {
            title: 'Medium Italic',
            fontWeight: 500,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '500i',
        },
        [FontVariant.SEMI_BOLD]: {
            title: 'Semi-Bold',
            fontWeight: 600,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '600',
        },
        [FontVariant.SEMI_BOLD_ITALIC]: {
            title: 'Semi-Bold Italic',
            fontWeight: 600,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '600i',
        },
        [FontVariant.BOLD]: {
            title: 'Bold',
            fontWeight: 700,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '700',
        },
        [FontVariant.BOLD_ITALIC]: {
            title: 'Bold Italic',
            fontWeight: 700,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '700i',
        },
        [FontVariant.EXTRA_BOLD]: {
            title: 'Extra-Bold',
            fontWeight: 800,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '800',
        },
        [FontVariant.EXTRA_BOLD_ITALIC]: {
            title: 'Extra-Bold Italic',
            fontWeight: 800,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '800i',
        },
        [FontVariant.BLACK]: {
            title: 'Black',
            fontWeight: 900,
            fontStyle: FontStyle.NORMAL,
            googleFontVariantParam: '900',
        },
        [FontVariant.BLACK_ITALIC]: {
            title: 'Black Italic',
            fontWeight: 900,
            fontStyle: FontStyle.ITALIC,
            googleFontVariantParam: '900i',
        },
    };

export class FontWeight extends AString
{
    public constructor(value:AString)
    {
        // super(value, FontWeight.types);
        super(value.toString());
    }

    // public toString():string
    // {
    // 	return this.value ? this.value.toString() : null;
    // }

    // public static fromString(value:string):FontWeight
    // {
    // 	// return new FontWeight(AString.fromString(value));
    // 	return AString.fromString(value);
    // }

    public static _thin = new AString(FontVariant.THIN);
    public static _extraLight = new AString(FontVariant.EXTRA_LIGHT);
    public static _light = new AString(FontVariant.LIGHT);
    public static _regular = new AString(FontVariant.REGULAR);
    public static _medium = new AString(FontVariant.MEDIUM);
    public static _semiBold = new AString(FontVariant.SEMI_BOLD);
    public static _bold = new AString(FontVariant.BOLD);
    public static _extraBold = new AString(FontVariant.EXTRA_BOLD);
    public static _black = new AString(FontVariant.BLACK);

    public static _thinItalic = new AString(FontVariant.THIN_ITALIC);
    public static _extraLightItalic = new AString(FontVariant.EXTRA_LIGHT_ITALIC);
    public static _lightItalic = new AString(FontVariant.LIGHT_ITALIC);
    public static _italic = new AString(FontVariant.ITALIC);
    public static _mediumItalic = new AString(FontVariant.MEDIUM_ITALIC);
    public static _semiBoldItalic = new AString(FontVariant.SEMI_BOLD_ITALIC);
    public static _boldItalic = new AString(FontVariant.BOLD_ITALIC);
    public static _extraBoldItalic = new AString(FontVariant.EXTRA_BOLD_ITALIC);
    public static _blackItalic = new AString(FontVariant.BLACK_ITALIC);

    // public static _thin = new AString(FontVariantTitles[FontVariant.THIN]);
    // public static _extraLight = new AString(FontVariantTitles[FontVariant.EXTRA_LIGHT]);
    // public static _light = new AString(FontVariantTitles[FontVariant.LIGHT]);
    // public static _regular = new AString(FontVariantTitles[FontVariant.REGULAR]);
    // public static _medium = new AString(FontVariantTitles[FontVariant.MEDIUM]);
    // public static _semiBold = new AString(FontVariantTitles[FontVariant.SEMI_BOLD]);
    // public static _bold = new AString(FontVariantTitles[FontVariant.BOLD]);
    // public static _extraBold = new AString(FontVariantTitles[FontVariant.EXTRA_BOLD]);
    // public static _black = new AString(FontVariantTitles[FontVariant.BLACK]);
    //
    // public static _thinItalic = new AString(FontVariantTitles[FontVariant.THIN_ITALIC]);
    // public static _extraLightItalic = new AString(FontVariantTitles[FontVariant.EXTRA_LIGHT_ITALIC]);
    // public static _lightItalic = new AString(FontVariantTitles[FontVariant.LIGHT_ITALIC]);
    // public static _italic = new AString(FontVariantTitles[FontVariant.ITALIC]);
    // public static _mediumItalic = new AString(FontVariantTitles[FontVariant.MEDIUM_ITALIC]);
    // public static _semiBoldItalic = new AString(FontVariantTitles[FontVariant.SEMI_BOLD_ITALIC]);
    // public static _boldItalic = new AString(FontVariantTitles[FontVariant.BOLD_ITALIC]);
    // public static _extraBoldItalic = new AString(FontVariantTitles[FontVariant.EXTRA_BOLD_ITALIC]);
    // public static _blackItalic = new AString(FontVariantTitles[FontVariant.BLACK_ITALIC]);
    //
    public static types:Array<AString> = [
        FontWeight._thin,
        FontWeight._extraLight,
        FontWeight._light,
        FontWeight._regular,
        FontWeight._medium,
        FontWeight._semiBold,
        FontWeight._bold,
        FontWeight._extraBold,
        FontWeight._black,

        FontWeight._thinItalic,
        FontWeight._extraLightItalic,
        FontWeight._lightItalic,
        FontWeight._italic,
        FontWeight._mediumItalic,
        FontWeight._semiBoldItalic,
        FontWeight._boldItalic,
        FontWeight._extraBoldItalic,
        FontWeight._blackItalic,
    ];

    // public static thin():FontWeight
    // {
    // 	return new FontWeight(FontWeight._thin);
    // }
    //
    // public static extraLight():FontWeight
    // {
    // 	return new FontWeight(FontWeight._extraLight);
    // }
    //
    // public static light():FontWeight
    // {
    // 	return new FontWeight(FontWeight._light);
    // }

    public static regular():FontWeight
    {
        return new FontWeight(FontWeight._regular);
    }

    public static medium():FontWeight
    {
        return new FontWeight(FontWeight._medium);
    }

    public static semiBold():FontWeight
    {
        return new FontWeight(FontWeight._semiBold);
    }

    public static bold():FontWeight
    {
        return new FontWeight(FontWeight._bold);
    }

    // public static extraBold():FontWeight
    // {
    // 	return new FontWeight(FontWeight._extraBold);
    // }
    //
    // public static black():FontWeight
    // {
    // 	return new FontWeight(FontWeight._black);
    // }
    //
    // public static thinItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._thinItalic);
    // }
    //
    // public static extraLightItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._extraLightItalic);
    // }
    //
    // public static lightItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._lightItalic);
    // }
    //
    // public static italic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._italic);
    // }
    //
    // public static mediumItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._mediumItalic);
    // }
    //
    // public static semiBoldItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._semiBoldItalic);
    // }
    //
    // public static boldItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._boldItalic);
    // }
    //
    // public static extraBoldItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._extraBoldItalic);
    // }
    //
    // public static blackItalic():FontWeight
    // {
    // 	return new FontWeight(FontWeight._blackItalic);
    // }

    // public static getFilteredTitles(variants:FontVariants):Array<AString>
    // {
    // 	const filteredTypes = [];
    //
    // 	console.log('%c getFilteredTitles =', 'background:#fcf;color:#000;', variants);
    //
    // 	// const variantsKeys = [...variants.keys()];
    //
    // 	// console.log('%c FontVariant =', 'background:#0f0;color:#000;', FontVariant);
    //
    // 	variants.forEach((variantValue:boolean, variant:FontVariant) =>
    // 	{
    // 		const fontVariantTitle = FontVariantItems[variant];
    // 		// console.log('%c variant =', 'background:#0f0;color:#000;', variant, '=', fontVariantTitle);
    //
    // 		filteredTypes.push(AString.fromString(fontVariantTitle));
    // 	});
    //
    // 	return filteredTypes;
    // }

    public static getFilteredVariants(variants:FontVariants):Array<AString>
    {
        return Array.from(variants.keys()).map(AString.fromString);
    }

    // public static stringToCSSValue(value:AString):100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900
    // {
    // 	switch( value.value )
    // 	{
    // 		case FontWeight._thin.value:
    // 			return 100;
    //
    // 		case FontWeight._extraLight.value:
    // 			return 200;
    //
    // 		case FontWeight._light.value:
    // 			return 300;
    //
    // 		case FontWeight._regular.value:
    // 			return 400;
    //
    // 		case FontWeight._medium.value:
    // 			return 500;
    //
    // 		case FontWeight._semiBold.value:
    // 			return 600;
    //
    // 		case FontWeight._bold.value:
    // 			return 700;
    //
    // 		case FontWeight._extraBold.value:
    // 			return 800;
    //
    // 		case FontWeight._black.value:
    // 			return 900;
    // 	}
    // }

    public static stringToCSSStyleValue(value:AString):FontStyleCSSValue
    {
        const fontVariantItem = fontVariantItems[value.value];

        if( fontVariantItem )
            return fontVariantItem.fontStyle;

        // switch( value.value )
        // {
        // 	case FontWeight._thin.value:
        // 	case FontWeight._extraLight.value:
        // 	case FontWeight._light.value:
        // 	case FontWeight._regular.value:
        // 	case FontWeight._medium.value:
        // 	case FontWeight._semiBold.value:
        // 	case FontWeight._bold.value:
        // 	case FontWeight._extraBold.value:
        // 	case FontWeight._black.value:
        // 		return 'normal';
        //
        // 	case FontWeight._thinItalic.value:
        // 	case FontWeight._extraLightItalic.value:
        // 	case FontWeight._lightItalic.value:
        // 	case FontWeight._italic.value:
        // 	case FontWeight._mediumItalic.value:
        // 	case FontWeight._semiBoldItalic.value:
        // 	case FontWeight._boldItalic.value:
        // 	case FontWeight._extraBoldItalic.value:
        // 	case FontWeight._blackItalic.value:
        // 		return 'italic';
        // }
    }

    public static stringToCSSWeightValue(value:AString):FontWeightCSSValue
    {
        const fontVariantItem = fontVariantItems[value.value];

        if( fontVariantItem )
            return fontVariantItem.fontWeight;

        // switch( value.value )
        // {
        // 	case FontWeight._thin.value:
        // 	case FontWeight._thinItalic.value:
        // 		return 100;
        //
        // 	case FontWeight._extraLight.value:
        // 	case FontWeight._extraLightItalic.value:
        // 		return 200;
        //
        // 	case FontWeight._light.value:
        // 	case FontWeight._lightItalic.value:
        // 		return 300;
        //
        // 	case FontWeight._regular.value:
        // 	case FontWeight._italic.value:
        // 		return 400;
        //
        // 	case FontWeight._medium.value:
        // 	case FontWeight._mediumItalic.value:
        // 		return 500;
        //
        // 	case FontWeight._semiBold.value:
        // 	case FontWeight._semiBoldItalic.value:
        // 		return 600;
        //
        // 	case FontWeight._bold.value:
        // 	case FontWeight._boldItalic.value:
        // 		return 700;
        //
        // 	case FontWeight._extraBold.value:
        // 	case FontWeight._extraBoldItalic.value:
        // 		return 800;
        //
        // 	case FontWeight._black.value:
        // 	case FontWeight._blackItalic.value:
        // 		return 900;
        // }
    }

    public static toCSS(value:AString):any
    {
        // let fontWeight = 'normal';
        // let fontStyle = 'normal';
        //
        // // const variant = FontWeight.toGoogleVariantValue(value);
        // const variant:string = FontWeight.toGoogleVariantValue(value.value);
        //
        // if( variant.indexOf('i') !== -1 ) fontStyle = 'italic';
        //
        // const weight = variant.match(/(\d{3}).*/);
        //
        // if( weight ) fontWeight = weight[1];

        // return {fontWeight, fontStyle};
        return {
            fontWeight: this.stringToCSSWeightValue(value),
            fontStyle: this.stringToCSSStyleValue(value)
        };
    }

    public static toGoogleFontVariantParam(value:FontVariant):GoogleFontVariantParam
    {
        const fontVariantItem = fontVariantItems[value];

        if( fontVariantItem )
            return fontVariantItem.googleFontVariantParam;

        // switch( value )
        // {
        // 	case FontWeight._thin.value:
        // 		return '100';
        // 	case FontWeight._extraLight.value:
        // 		return '200';
        // 	case FontWeight._light.value:
        // 		return '300';
        // 	case FontWeight._regular.value:
        // 		return 'regular';
        // 	case FontWeight._medium.value:
        // 		return '500';
        // 	case FontWeight._semiBold.value:
        // 		return '600';
        // 	case FontWeight._bold.value:
        // 		return '700';
        // 	case FontWeight._extraBold.value:
        // 		return '800';
        // 	case FontWeight._black.value:
        // 		return '900';
        //
        // 	case FontWeight._thinItalic.value:
        // 		return '100i';
        // 	case FontWeight._extraLightItalic.value:
        // 		return '200i';
        // 	case FontWeight._lightItalic.value:
        // 		return '300i';
        // 	case FontWeight._italic.value:
        // 		return 'italic';
        // 	case FontWeight._mediumItalic.value:
        // 		return '500i';
        // 	case FontWeight._semiBoldItalic.value:
        // 		return '600i';
        // 	case FontWeight._boldItalic.value:
        // 		return '700i';
        // 	case FontWeight._extraBoldItalic.value:
        // 		return '800i';
        // 	case FontWeight._blackItalic.value:
        // 		return '900i';
        // }
    }

    public static getTitle(value:AString):FontVariantTitle
    {
        if( !value ) return;

        const fontVariantItem = fontVariantItems[value.value];

        if( fontVariantItem )
            return fontVariantItem.title;
    }

    // public static getAllFontVariants():FontVariant[]
    // {
    // 	return FontWeight.types.map((typeValue:AString) =>
    // 	{
    // 		return FontWeight.getFontVariantByValue(typeValue);
    // 	});
    // }

    // public static getFontVariantByValue(value:AString):FontVariant
    // {
    // 	console.log('%c getFontVariantByValue value =', 'background:#000;color:#ff0;', value);
    // 	let fontVariant:FontVariant = null;
    //
    // 	Object.keys(fontVariantItems).forEach((key:FontVariant) =>
    // 	{
    // 		if( fontVariant ) return;
    // 		if( fontVariantItems[key] === value.toString() ) fontVariant = key;
    // 	});
    //
    // 	return fontVariant;
    // }
}
